import { PageHead } from "../components/ui";

/** Estrutura de navegação da F1: o módulo existe no menu, sem tela operacional (funcionalidades financeiras: F2 em diante). */
export function ModuleStub({ title }: { title: string }) {
  return (
    <>
      <PageHead title={title} />
      <div className="card stub">
        <h3>Módulo em preparação</h3>
        <p className="muted" style={{ margin: 0 }}>Este módulo faz parte da estrutura de navegação do MM Money e será disponibilizado em uma fase futura.</p>
      </div>
    </>
  );
}
